export default __webpack_public_path__ + "static/media/uploader-abbottXtra-1.f02ddc3b.png";